import { createContext } from "react";
/**
 * Use viewLevel when calculating layout
 * @category Settings
 */
export const ViewLevelEnabledContext = createContext(true);
ViewLevelEnabledContext.displayName = "ViewLevelEnabledContext";
//# sourceMappingURL=ViewLevelEnabledContext.js.map